import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'
import { AWS_BASE, CLOUDFLARE_DEFAULT_BASE } from '../../../constants'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-left: ${Spacing.XLarge}px;
  padding-right: ${Spacing.XLarge}px;

  @media (max-width: 320px) {
    padding-left: ${Spacing.Large}px;
    padding-right: ${Spacing.Large}px;
  }
`

export const Bottom = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${Spacing.Large}px;

  @media (max-height: 700px) {
    position: relative;
    padding: ${Spacing.XLarge}px 0;
  }
`

export const PackagingImage = styled.div`
  width: 100%;
  height: 178px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${`${CLOUDFLARE_DEFAULT_BASE},height=250/${AWS_BASE}/img/dasher/dd-welcome-bag.png`});
`
